module.exports = __webpack_public_path__ + "img/search.dd953465.png";